import { render, staticRenderFns } from "./TwoCols.vue?vue&type=template&id=1bcde3f8&scoped=true&"
import script from "./TwoCols.vue?vue&type=script&lang=js&"
export * from "./TwoCols.vue?vue&type=script&lang=js&"
import style0 from "./TwoCols.vue?vue&type=style&index=0&id=1bcde3f8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcde3f8",
  null
  
)

export default component.exports